export * from "./type";
export * from "./common-resource-keys";
export * from "./game-resource-keys";
export * from "./message-resource-keys";
